import * as React from 'react';

function WinterSports(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.77 17.794H3l3.85-7.698 2.767-1.063L11.743 5 21.77 17.794zm-17.542-.77h15.929l-3.574-4.142-1.045-.513-1.357-2.2.679 2.2-.019 2.768-.293-2.915-1.082-2.493-.99-.66-.091.935-.385.165-.586-.495-.679.495-1.228.055-.77 1.32-.77.788-.733 3.208.458-3.446.807-1.302-1.081.99-.679 1.265-2.51 3.977z"
        fill="currentColor"
      />
    </svg>
  );
}

export default WinterSports;
